import { HttpError, httpClient } from "@/utils/api"
import {
  XLSX_EXPORT_BLOB_TYPE,
  exportBlobType,
  fileNameFromContentDisposition,
  toExportHttpError,
} from "@/utils/export-blob"

export interface BillsExportFile {
  blob: Blob
  fileName: string
}

const defaultExportFileName = (blobType: string): string =>
  blobType === XLSX_EXPORT_BLOB_TYPE ? "Bills.xlsx" : "Bills.csv"

export const getBillsExport = async (
  href: string
): Promise<BillsExportFile> => {
  try {
    const response = await httpClient.get<Blob>(href, {
      responseType: "blob",
    })
    const blobType = exportBlobType(response.headers["content-type"])

    if (!(response.data instanceof Blob) || blobType === undefined) {
      throw new HttpError({
        errors: [],
        message: "Unexpected export response",
        status: response.status,
      })
    }

    return {
      blob: new Blob([response.data], { type: blobType }),
      fileName: fileNameFromContentDisposition(
        response.headers["content-disposition"],
        defaultExportFileName(blobType)
      ),
    }
  } catch (error: unknown) {
    throw await toExportHttpError(error)
  }
}
